import React, { useRef, useState } from 'react';
import { Dropdown, DropdownProps, Form } from 'semantic-ui-react';

export type Props = {
  onChange?: (...args: any[]) => void;
  placeholder?: string;
  label?: string;
  id?: string;
  value?: string[];
  error?: string;
  name?: string;
} & DropdownProps;

const DropdownField: React.FC<Props> = (props) => {
  const { label, error, onAddItem, onChange, ...rest } = props;
  const [loading] = useState<boolean>(false);
  const optionsRef = useRef<DropdownProps['options']>(
    props.options ||
      props.value?.map((v) => ({
        text: v,
        value: v as string,
        key: v,
      })) ||
      [],
  );

  const handleAddItem: DropdownProps['onAddItem'] = async (event, data) => {
    optionsRef.current?.push({
      text: data.value,
      value: data.value as string,
      key: data.value,
    });

    onChange?.(event, { value: optionsRef.current });
    onAddItem?.(event, data);
  };

  return (
    <Form.Field error={!!error}>
      <label>{label}</label>
      <Dropdown
        selection
        allowAdditions
        search
        multiple
        additionLabel={''}
        onAddItem={props.allowAdditions ? handleAddItem : undefined}
        loading={loading}
        disabled={loading}
        options={optionsRef.current}
        onChange={onChange}
        {...rest}
      />
      {error && <div className="ui pointing above prompt label">{error}</div>}
    </Form.Field>
  );
};

export default DropdownField;
